import { CreateShareInfoComponent } from './create-info.component';

export default CreateShareInfoComponent;
